export default __webpack_public_path__ + "static/media/5_T.7237fba8.png";